module.exports = __webpack_public_path__ + "img/multiple_choice.4e69197e.svg";